/* eslint-disable @typescript-eslint/no-explicit-any */
import AT from '../constants/action-types';
import { SignInData } from '../api';

export function userSigninAC(formData: SignInData) {
  return { type: AT.USER_SIGNIN_SAGA, formData };
}

export function appInitAC() {
  return { type: AT.APP_INIT_SAGA };
}

export function userSignoutAC() {
  return { type: AT.USER_SIGNOUT_SAGA };
}

export function sendCbxConfigAC(id: any) {
  return { type: AT.CONTROL_BOX_COMMAND_SAGA, cmd: 'send-cbx-config', id };
}
export function restartControlBoxAC(id: any) {
  return { type: AT.CONTROL_BOX_COMMAND_SAGA, cmd: 'cbx-restart', id };
}

export function cbxUpdateAC(id: any) {
  return { type: AT.CONTROL_BOX_COMMAND_SAGA, cmd: 'cbx-update', id };
}

export function reloadControlBoxAC(id: any) {
  return { type: AT.CONTROL_BOX_COMMAND_SAGA, cmd: 'cbx-reload', id };
}

export function configDisplayAC(id: any, address: any) {
  return {
    type: AT.CONTROL_BOX_COMMAND_SAGA,
    cmd: 'config-display',
    id,
    address
  };
}

export function startKioskSSHTunnelAC(id: any) {
  return { type: AT.KIOSK_COMMAND_SAGA, cmd: 'start-tunnel', id };
}


export function updateKioskAC(data: any) {
  return { type: AT.UPDATE_KIOSK_SAGA, data };
}

export function saveControlBoxAC(opts: any) {
  return { type: AT.SAVE_CONTROL_BOX_SAGA, ...opts };
}

export function saveKioskAC(opts: any) {
  return { type: AT.SAVE_KIOSK_SAGA, ...opts };
}

export function saveQueueAC(opts: any) {
  return { type: AT.SAVE_QUEUE_SAGA, ...opts };
}

export function saveBoothAC(opts: any) {
  return { type: AT.SAVE_BOOTH_SAGA, ...opts };
}

export function saveDisplayAC(opts: any) {
  return { type: AT.SAVE_DISPLAY_SAGA, ...opts };
}

export function saveServiceAC(opts: any) {
  return { type: AT.SAVE_SERVICE_SAGA, ...opts };
}

export function saveLocationAC(opts: any) {
  return { type: AT.SAVE_LOCATION_SAGA, ...opts };
}

export function deleteItemAC(opts: any) {
  return { type: AT.DELETE_ITEM_SAGA, ...opts };
}

export function deleteBoothAC(id: any) {
  return deleteItemAC({ itemType: 'Booth', itemId: id });
}

export function deleteDisplayAC(id: any) {
  return deleteItemAC({ itemType: 'Display', itemId: id });
}

export function deleteKioskAC(id: any) {
  return deleteItemAC({ itemType: 'Kiosk', itemId: id });
}

export function deleteServiceAC(id: any) {
  return deleteItemAC({ itemType: 'Service', itemId: id });
}

export function deleteLocationAC(id: any) {
  return deleteItemAC({ itemType: 'Location', itemId: id });
}

export function deleteControlBoxAC(id: any) {
  return deleteItemAC({ itemType: 'ControlBox', itemId: id });
}

export function deleteQueueAC(id: any) {
  return deleteItemAC({ itemType: 'Queue', itemId: id });
}

export function simpleSetupAC(data: any, resolve: any, reject: any) {
  return { type: AT.SIMPLE_SETUP_SAGA, data, resolve, reject };
}

export function setupMessageTracker(data?: any) {
  return { type: AT.MESSAGE_TRACKER_SAGA, ...data };
}
export function searchLog(filter: any) {
  return { type: AT.SEARCH_LOG_SAGA, filter };
}

export function providerDeviceStatusSaga(serviceProviderId: any) {
  return { type: AT.PROVIDER_DEVICE_STATUS_SAGA, serviceProviderId };
}

export function httpErrorAC(resData: any) {
  return { type: AT.HTTP_ERROR_SAGA, ...resData };
}
